import { Entity, Column, PrimaryGeneratedColumn, OneToMany, Index } from 'typeorm'

import Question from './Question'

import { SurveyType, TestType } from '../entityTypes'
import RespondentSurvey from '../RespondentSurvey'
import SurveyAudience from './SurveyAudience'
import SurveyEvent from './SurveyEvent'

export enum StatusChangeSource {
  User = 'user',
  Automated = 'automated'
}

export enum SurveyStatus {
  ACTIVE='active',
  ACTIVE_FF='active_ff',
  DRAFT='draft',
  INACTIVE='inactive'
}

@Entity('surveys')
@Index(['workspaceId', 'testId'])
export default class Survey {
  @PrimaryGeneratedColumn('uuid')
  id!: string

  @Column({ name: 'created_at' })
  createdAt!: Date

  @Column({ name: 'updated_at' })
  updatedAt!: Date

  @Column({ nullable: true, type: 'enum', enum: SurveyType })
  type!: SurveyType

  @Column({ name: 'workspace_id' })
  workspaceId!: string

  @Column({ name: 'test_id' })
  testId!: string

  @Column({ nullable: true, name: 'org_id' })
  orgId?: string

  @Column({ type: 'enum', enum: SurveyStatus })
  status!: SurveyStatus

  @Column({ name: 'submitted_by' })
  submittedBy!: string

  @Column({ name: 'qtest_uid' })
  qtestUid!: string

  @Column({ type: 'enum', enum: TestType, name: 'test_type' })
  testType!: TestType

  // before mid 2019 it was a human readble snakecase string, now its hash
  @Column({ nullable: true, name: 'qtest_segment_id' })
  qtestSegmentId?: string

  // segment from qtest is gp gp2 gp3 gp4 etc.
  @Column({ name: 'is_gp' })
  isGp!: boolean

  @Column({ name: 'qtest_tap_id' })
  @Index({ unique: true })
  qtestTapId!: string

  @Column({ nullable: true, name: 'exclude_from_queue' })
  excludeFromQueue?: boolean

  @OneToMany(type => Question, question => question.survey)
  questions?: Question[]

  @OneToMany(type => RespondentSurvey, rs => rs.survey)
  respondentSurveys?: RespondentSurvey[]

  @OneToMany(type => SurveyAudience, s => s.survey)
  surveyAudiences!: SurveyAudience[]

  @Column({ name: 'status_change_source', type: 'enum', enum: StatusChangeSource, nullable: true })
  statusChangeSource?: StatusChangeSource

  @OneToMany(type => SurveyEvent, s => s.survey)
  surveyEvents!: SurveyEvent[]

  // asset hash
}
